import { Box, IconButton, Button, VStack } from "@chakra-ui/react"
import { LuEllipsisVertical, LuCopy, LuFileCode } from "react-icons/lu";
import { PopoverBody, PopoverContent, PopoverRoot, PopoverTrigger } from "./popover";
import { toaster } from "./toaster";

interface MoreOptionsProps {
    botAnswer?: string;
}

export const MoreOptions = ({ botAnswer }: MoreOptionsProps) => {

    const copyToClipboard = (text: string, description: string) => {
        navigator.clipboard.writeText(text).then(() => {
            toaster.create({
                title: "Copied to clipboard",
                description: description,
                type: "success",
            });
        }).catch((err) => {
            console.error('Could not copy text: ', err);
            toaster.create({
                title: "Failed to copy",
                description: "An error occurred while copying to clipboard",
                type: "error",
            });
        });
    };

    const stripMarkdownAndHtml = (text: string) => {
        // Remove HTML tags
        let cleanText = text.replace(/<\/?[^>]+(>|$)/g, "");
        // Remove Markdown formatting
        cleanText = cleanText
            .replace(/(\*\*|__)(.*?)\1/g, "$2") // Bold
            .replace(/(\*|_)(.*?)\1/g, "$2")    // Italic
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1") // Links
            .replace(/#{1,6}\s+(.*)/g, "$1")    // Headers
            .replace(/`{1,3}([^`]+)`{1,3}/g, "$1") // Code blocks
            .replace(/>\s+(.*)/g, "$1")         // Blockquotes
            .replace(/[-*+]\s+(.*)/g, "$1")     // Unordered lists
            .replace(/\d+\.\s+(.*)/g, "$1");    // Ordered lists

        return cleanText.trim();
    };

    const handleCopyPlainText = () => {
        if (!botAnswer) return;
        const plainText = stripMarkdownAndHtml(botAnswer);
        copyToClipboard(plainText, "Plain text copied");
    };

    const handleCopyRawText = () => {
        if (!botAnswer) return;
        copyToClipboard(botAnswer, "Raw text (Markdown/HTML) copied");
    };

    return (
        <Box>
            <PopoverRoot positioning={{ placement: "bottom-end" }} children={
                <>
                    <PopoverTrigger asChild>
                        <IconButton
                            borderRadius={'full'}
                            size={'xs'}
                            variant={'ghost'}
                            aria-label="More Options"
                        >
                            <LuEllipsisVertical aria-hidden="true" />
                        </IconButton>
                    </PopoverTrigger>
                    <PopoverContent width="auto">
                        <PopoverBody p="2">
                            <VStack align="stretch">
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    justifyContent="flex-start"
                                    onClick={handleCopyPlainText}
                                >
                                    <LuCopy aria-hidden="true" /> Copy Plain Text
                                </Button>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    justifyContent="flex-start"
                                    onClick={handleCopyRawText}
                                >
                                    <LuFileCode aria-hidden="true" /> Copy Raw Text
                                </Button>
                            </VStack>
                        </PopoverBody>
                    </PopoverContent>
                </>
            } />
        </Box>
    )

}
